module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "register",
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "registBasic",
    staticClass: "register-form",
    attrs: {
      "model": _vm.regist,
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("账号信息填写")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username",
      "rules": [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.regist.username),
      callback: function($$v) {
        _vm.$set(_vm.regist, "username", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "regist.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd",
      "rules": [{
        required: true,
        validator: _vm.validatePass,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.regist.pwd),
      callback: function($$v) {
        _vm.$set(_vm.regist, "pwd", $$v)
      },
      expression: "regist.pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd2",
      "rules": [{
        required: true,
        validator: _vm.validatePass2,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "确认密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.regist.pwd2),
      callback: function($$v) {
        _vm.$set(_vm.regist, "pwd2", $$v)
      },
      expression: "regist.pwd2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "registExtra",
    staticClass: "register-form",
    attrs: {
      "model": _vm.regist,
      "size": "medium"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("基本信息填写")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "name",
      "rules": [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "联系人（请输入真实姓名）"
    },
    model: {
      value: (_vm.regist.name),
      callback: function($$v) {
        _vm.$set(_vm.regist, "name", $$v)
      },
      expression: "regist.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone",
      "rules": [{
        required: true,
        validator: _vm.checkPhone,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "联系电话（作为我们联系您的方式请务必真实）"
    },
    model: {
      value: (_vm.regist.phone),
      callback: function($$v) {
        _vm.$set(_vm.regist, "phone", $$v)
      },
      expression: "regist.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "rules": [{
        required: true,
        validator: _vm.checkEmail,
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱（作为我们联系您的方式请务必真实）"
    },
    model: {
      value: (_vm.regist.email),
      callback: function($$v) {
        _vm.$set(_vm.regist, "email", $$v)
      },
      expression: "regist.email"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择学校"
    },
    model: {
      value: (_vm.regist.school),
      callback: function($$v) {
        _vm.$set(_vm.regist, "school", $$v)
      },
      expression: "regist.school"
    }
  }, _vm._l((_vm.schools), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (_vm.regist.school == '0') ? _c('el-form-item', {
    attrs: {
      "prop": "otherschool"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入学校名称"
    },
    model: {
      value: (_vm.regist.otherschool),
      callback: function($$v) {
        _vm.$set(_vm.regist, "otherschool", $$v)
      },
      expression: "regist.otherschool"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "province",
      "rules": [{
        required: true,
        message: '请选择省份',
        trigger: 'blur'
      }]
    }
  }, [_c('el-select', {
    staticClass: "cselect",
    attrs: {
      "filterable": "",
      "placeholder": "请选择学校所在省份"
    },
    model: {
      value: (_vm.regist.province),
      callback: function($$v) {
        _vm.$set(_vm.regist, "province", $$v)
      },
      expression: "regist.province"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "addr",
      "rules": [{
        required: true,
        message: '请输入地址',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "地址"
    },
    model: {
      value: (_vm.regist.addr),
      callback: function($$v) {
        _vm.$set(_vm.regist, "addr", $$v)
      },
      expression: "regist.addr"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "register-confirm"
  }, [_c('span', {
    staticClass: "submit",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('div', {
    staticClass: "go_login"
  }, [_c('a', {
    attrs: {
      "href": "#/login"
    }
  }, [_vm._v("已有账号？点此处登陆")])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_wrap"
  }, [_c('span', {
    staticClass: "title_name"
  }, [_vm._v("创建新账号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f22b5a70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Regist.vue
// module id = 629
// module chunks = 1